import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const DoubleChin = lazyWithPreload(() => import('./DoubleChin'))
